// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2wFD0","Label":"BuildControl_Label__J-J0_"};